'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findContact = exports.fetchContactsNear = exports.fetchContacts = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchContacts = exports.fetchContacts = function fetchContacts(clientId) {
  return (0, _callApi2.default)('GET', '/contacts/' + clientId);
};
var fetchContactsNear = exports.fetchContactsNear = function fetchContactsNear(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      lng = _ref2[0],
      lat = _ref2[1];

  return (0, _callApi2.default)('POST', '/integrations/cole/data-near', { coords: [lng, lat] }, 'application/json');
};
var findContact = exports.findContact = function findContact(_ref3) {
  var street_name = _ref3.street_name,
      house_number = _ref3.house_number,
      zip = _ref3.zip,
      state = _ref3.state;
  return (0, _callApi2.default)('POST', '/integrations/cole/find-contact', { street_name: street_name, house_number: house_number, zip: zip, state: state }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/contacts.js
// module id = 728
// module chunks = 0